import React from "react";
import "./Home.css";
import CounterDetails from "../CounterDetails/counterDetails";
import Header from "../Header/Header";
import Graph from "../Graph/Graph";
import PremiumProduct from "../gplus-premium/premiumProduct";
// import JoyEbike from "../Joy-e-bike/JoyEbike";
import Gpluspage from "../Gpluspage/Gpluspage";
import Journals from "../Journals/Journals";
// import Appreciation from "../Appreciation/Appreciation";
import Digital from "../DigitalPlateForm/Digital";
// import Award from "../Award/Award";
const Home = () => {

  return (
    <div className="font-OpenSans bg-white text-black">
      <Header />
      <CounterDetails />

      <Graph />
      
      <Gpluspage />
      <PremiumProduct />
      
      <Journals/>
      {/* <Appreciation/> */}
      <Digital />
      {/* <Award/> */}

      
      
      
     

     

    
     
      
    </div>
  );
};

export default Home;
